import React from 'react';

import MSContextTable from './MSContextTable.jsx';

function IMSContext() {
  return (
      <MSContextTable />
  );
}

export default IMSContext;